import React from 'react';
import { AlertDialog, FormTextField } from "../../../../components";
import { getI18nFormattedMessage } from "../../../../utils/intl";
import { bool, func, shape, string } from "prop-types";
import { isEmpty } from 'lodash';

const EditApiLocationDialog = (props) => {
  const {
    locationUrl, onLocationUrlChange, isAlertDialogOpen,
    onSave, onCancel, onRestoreDefault, classes, disableRestoreDefault,
  } = props
  const innerComponent = () =>
    <FormTextField
      id={'api-location-edit-dialog-location-url'}
      name={getI18nFormattedMessage('label.api.location')}
      value={locationUrl}
      handleChange={onLocationUrlChange}
      handleBlur={onLocationUrlChange}
      helperText={getI18nFormattedMessage('label.api.location.tab.edit.dialog.url.limit')}
    />
  return <AlertDialog
    id="api-location-edit-dialog"
    data-apim-test="api-location-edit-dialog"
    isOpen={isAlertDialogOpen}
    title={getI18nFormattedMessage('label.api.location.tab.edit.dialog.title')}
    submitText={getI18nFormattedMessage('label.api.location.tab.edit.dialog.save.button')}
    cancelText={getI18nFormattedMessage('label.cancel.button')}
    defaultText={getI18nFormattedMessage('label.api.location.tab.edit.dialog.restore.default.button')}
    showDefault
    onSubmit={onSave}
    disableSubmit={isEmpty(locationUrl)}
    onClose={onCancel}
    onCancel={onCancel}
    onDefault={onRestoreDefault}
    disableDefault={disableRestoreDefault}
    defaultButtonClass={classes.restoreDefaultButton}
    component={innerComponent()}
  />
}

EditApiLocationDialog.propTypes = {
  isAlertDialogOpen : bool,
  setIsAlertDialogOpen : func,
  onSave : func,
  onCancel : func,
  onRestoreDefault : func,
  onLocationUrlChange : func,
  classes : shape({ }),
  locationUrl : string,
  setLocationUrl : func,
  disableRestoreDefault : bool,
}

export default EditApiLocationDialog;
